
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Check, CheckCircle2, Clock, File, X } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface Document {
  id: string;
  verification_status: string;
  submitted_at: string;
  primary_document?: boolean;
  document_type?: string;
}

interface DocumentsListProps {
  documents: Document[];
}

export const DocumentsList = ({ documents }: DocumentsListProps) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center text-lg">
          <File className="mr-2 h-5 w-5 text-nation-blue" />
          My Documents
        </CardTitle>
      </CardHeader>
      <CardContent>
        {documents.length === 0 ? (
          <div className="text-center py-4 text-muted-foreground">
            No documents uploaded
          </div>
        ) : (
          <div className="space-y-3">
            {documents.map((doc) => (
              <div key={doc.id} className="flex items-center justify-between text-sm">
                <div className="flex-1">
                  <div className="font-medium flex items-center">
                    {doc.document_type || 'ID Document'}
                    {doc.primary_document && (
                      <Badge variant="secondary" className="ml-2 flex items-center gap-1">
                        <CheckCircle2 className="h-3 w-3" />
                        <span>Primary</span>
                      </Badge>
                    )}
                  </div>
                  <div className="text-xs text-muted-foreground">
                    {new Date(doc.submitted_at).toLocaleDateString()}
                  </div>
                </div>
                <div>
                  {doc.verification_status === 'verified' ? (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      <Check className="mr-1 h-3 w-3" />
                      Verified
                    </span>
                  ) : doc.verification_status === 'rejected' ? (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                      <X className="mr-1 h-3 w-3" />
                      Rejected
                    </span>
                  ) : (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800">
                      <Clock className="mr-1 h-3 w-3" />
                      Pending
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
